export default "__VITE_ASSET__Pbd5YYOc__"